"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.black = void 0;
var _styledComponents = require("styled-components");
const black = exports.black = (0, _styledComponents.css)`
  .lexus-theme.tippy-tooltip.background-white {
    background: #000;
    color: #fff;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='top'] > .tippy-arrow {
    border-top-color: #000;
    border-width: 8px 10px 0 10px;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='bottom'] > .tippy-arrow {
    border-bottom-color: #000;
    border-width: 0 10px 8px 10px;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='left'] > .tippy-arrow {
    border-left-color: #000;
    border-width: 10px 0 10px 8px;
  }
  .lexus-theme.tippy-tooltip.background-white[data-placement^='right'] > .tippy-arrow {
    border-right-color: #000;
    border-width: 10px 8px 10px 0;
  }
`;
const white = exports.white = (0, _styledComponents.css)`
  .lexus-theme.tippy-tooltip.background-black {
    background: #fff;
    color: #000;
  }
  .lexus-theme.tippy-tooltip.background-black[data-placement^='top'] > .tippy-arrow {
    border-top-color: #fff;
    border-width: 8px 10px 0 10px;
  }
  .lexus-theme.tippy-tooltip.background-black[data-placement^='bottom'] > .tippy-arrow {
    border-bottom-color: #fff;
    border-width: 0 10px 8px 10px;
  }
  .lexus-theme.tippy-tooltip.background-black[data-placement^='left'] > .tippy-arrow {
    border-left-color: #fff;
    border-width: 10px 0 10px 8px;
  }
  .lexus-theme.tippy-tooltip.background-black[data-placement^='right'] > .tippy-arrow {
    border-right-color: #fff;
    border-width: 10px 8px 10px 0;
  }
  .lexus-theme.tippy-tooltip.background-black .tippy-content button svg {
    fill: #000;
  }
`;